import { InputDatePicker } from 'react-ui-kit-exante';

import { styled } from 'theme';

export const StyledInputDatePicker = styled(InputDatePicker)`
  .InputBase-input {
    font-weight: 500;
  }
`;
